import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange } from '@angular/core';
import _ from 'lodash';
import { CustomOverlayMessaggeOptions } from './custom-overlay-messagge';
import { fadeInOutWithBlur } from '../global-app-animations';
import { Observable, Subject, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseDeleteError, BaseDeleteResponse, BaseResponse } from 'src/app/model/response/base-response';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ApiError } from 'src/app/model/global-interface';

@Component({
    selector: 'app-custom-overlay-messagge',
    templateUrl: './custom-overlay-messagge.component.html',
    styleUrl: './custom-overlay-messagge.component.scss',
    animations: [fadeInOutWithBlur],
    standalone: false
})
export class CustomOverlayMessaggeComponent implements OnInit, OnDestroy, OnChanges {

  @Input() options?: CustomOverlayMessaggeOptions;

  @Input() deleteItem?: string | number;

  @Output() dialogOpened: EventEmitter<any> = new EventEmitter<any>();
  @Output() dialogClosed: EventEmitter<any> = new EventEmitter<any>();

  @Output() okClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelClicked: EventEmitter<any> = new EventEmitter<any>();

  theEnd$: Subject<void> = new Subject<void>();

  baseHref = environment.baseHREF;


  status: 'idle' | 'loading' | 'response' = 'idle';
  error: string = '';
  deleteResponse?: ApiError = undefined;
  deleteResponseErrors?: BaseDeleteError[][] = undefined;

  parsedOptions: CustomOverlayMessaggeOptions;
  dialogVisible: boolean = false;

  constructor(private http: HttpClient, private router: Router) {
    if (this.options != undefined) {
      this.parsedOptions = this.options;
    } else {
      this.parsedOptions = {

      };
    }
  }


  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }

  ngOnChanges(changes: { options: SimpleChange }): void {
    if (changes.options) {
      this.updateOptions(changes.options.currentValue);
    }
  }

  parseOptions(){
    if (this.options != undefined) {
      this.parsedOptions = this.options;
    } else {
      this.parsedOptions = {

      };
    }
  }

  resetDialog() {
    this.status = 'idle';
    this.error = '';
    this.deleteResponse = undefined;
    this.deleteResponseErrors = undefined;
  }

  showDialog() {
    this.resetDialog();
    this.dialogVisible = true;
    this.dialogOpened.emit('opened');

    setTimeout(() => {
      let element = document.getElementById('cancelButtonOverlayMessagge');
      console.warn(element);
      element?.focus();
    }, 500);
  }

  hideDialogByButton(event: any) {
    this.dialogVisible = false;
    this.resetDialog();
    this.dialogClosed.emit(event);
    this.dialogClosed.emit(event);
  }

  cancelClick(event: any) {
    this.dialogVisible = false;
    this.resetDialog();
    this.cancelClicked.emit(event);
    this.dialogClosed.emit(event);
  }

  okClick(event: any) {
    if (this.options?.deleteDialogOptions != undefined) {
      this.delete();

    } else {

      this.dialogVisible = false;
      this.resetDialog();
      this.okClicked.emit(event);
    }
  }


  updateOptions(data: CustomOverlayMessaggeOptions) {
    this.parsedOptions = _.cloneDeep(data);
  }


  deleteObservable(): Observable<BaseDeleteResponse> {
    if(this.deleteItem != undefined) {
      this.deleteItem = encodeURIComponent(this.deleteItem);
    }
    return this.http.delete<BaseDeleteResponse>(`${this.options?.deleteDialogOptions?.deleteUrl}/${this.deleteItem}`);
  }

  delete() {
    let deleteOptions = this.options?.deleteDialogOptions;
    if (deleteOptions == undefined) {
      return;
    }
    this.status = 'loading';

    this.deleteObservable().pipe(takeUntil(this.theEnd$)).subscribe({
      next: (resp: BaseDeleteResponse) => {
        this.status = 'response';
        if (deleteOptions.deleteSuccessMessage != undefined) {
          this.error = `${deleteOptions.deleteSuccessMessage}`;
        } else {
          this.error = `${deleteOptions.deleteEntityName} ${deleteOptions.isFem ? 'eliminata' : 'eliminato'}`;
        }
        setTimeout(() => {
          this.cancelClick('');
          if (deleteOptions.redirectUrl) {
            this.router.navigate([deleteOptions.redirectUrl]);
          }
        }, 1500);
      },
      error: (resp: ApiError) => {

        this.deleteResponse = resp;
        //group shit by error
        // if (this.deleteResponse && this.deleteResponse.errors) {
        //   const groupedByError = this.deleteResponse.errors.reduce((acc, item) => {
        //     // If the key doesn't exist, create it and initialize with an empty array
        //     if (!acc[item.error]) {
        //       acc[item.error] = [];
        //     }
        //     // Push the current item into the array for this error
        //     acc[item.error].push(item);
        //     return acc;
        //   }, {} as { [key: string]: BaseDeleteError[] });

        //   this.deleteResponseErrors = Object.values(groupedByError);

        // }



        this.status = 'response';
        if (this.deleteResponse && this.deleteResponse.message.length > 0) {
          // if (this.deleteResponse.errorCode == environment.apiErrorCodes.LockedField) {
          //   this.error = `${deleteOptions.deleteEntityName} in modifica da '${this.deleteResponse.error}'.`;
          // } else {

            this.error = this.deleteResponse.message;
          //}

        } else {

          this.error = "Errore inaspettato, riprova";

        }

      }
    })
  }

  navigateToUrl(url: string) {
    window.open(url, '_blank');
  }

}
